/* elemé — global background-video autoplay hardening.
 * WHY: Shopify's video_tag doesn't reliably emit `playsinline`. Without it, mobile browsers
 * refuse to autoplay and render a tap-to-play button instead — which is what was appearing on
 * the homepage hero and the perfume PDP scenes. This forces the required attributes on every
 * background video (hero slides + perfume PDP scenes), strips controls, and retries once on
 * first user interaction for the strictest browsers (iOS Low Power Mode, Data Saver).
 * Scoped to background videos only — it deliberately does NOT touch product-gallery or
 * how-to-use videos, which are meant to have controls and stay user-initiated.
 */
(function () {
  var BG_SELECTORS = [
    '.eh__bg video',        // homepage hero slides
    '.epdp .hero__visual video', // perfume PDP hero
    '.epdp .scene__media video'  // perfume PDP scroll scenes
  ].join(',');

  function force(v) {
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('loop', '');
    v.setAttribute('autoplay', '');
    v.removeAttribute('controls');
    v.controls = false;
    if (v.paused) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* retried on interaction */ });
    }
  }

  function playAll() {
    document.querySelectorAll(BG_SELECTORS).forEach(force);
  }

  function init() {
    playAll();
    // Shopify's own player script can re-add controls after hydration — re-assert.
    setTimeout(playAll, 500);
    setTimeout(playAll, 1500);
    setTimeout(playAll, 3000);

    // Some browsers only release autoplay after a first gesture.
    ['touchstart', 'click', 'scroll', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function once() {
        playAll();
        window.removeEventListener(evt, once);
      }, { once: true, passive: true });
    });

    // Catch videos added later (theme editor edits, lazy sections).
    if (window.MutationObserver) {
      new MutationObserver(function () { playAll(); })
        .observe(document.body, { childList: true, subtree: true });
    }

    // Pause offscreen videos to save bandwidth and battery, resume when visible.
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) force(e.target);
          else if (!e.target.paused) e.target.pause();
        });
      }, { threshold: 0.1 });
      document.querySelectorAll(BG_SELECTORS).forEach(function (v) { io.observe(v); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
